module.exports = "<deduction-plan-page></deduction-plan-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/deduction.html
// module id = 1656
// module chunks = 0